import Vue from "vue";
import movieApi from "../../api/movieApi";
import storageProcess from "../../utils/storage/historyCompaireMovies"

// initial state
const state = {
  movieApi: new movieApi(),
  mainMovieId: undefined,
  cycleMoviesList: [],
  movieIdList: [],
  movieActive: {}
};

// getters
const getters = {
  getMovieApi(state) {
    return state.movieApi
  },
  getMainMovieId(state) {
    return state.mainMovieId
  },
  getCycleMoviesList(state) {
    return state.cycleMoviesList
  },
  getMovieList(state) {
    return state.movieIdList;
  },
  getMovieActive(state) {
    return state.movieActive
  },
  getTotalMovieIdList(state) {
    // 组织所有movie的list(    均值(id:0) + 周期对比影片(cycle)？ + 添加的对比影片(movielist) )
    return [0].concat(state.cycleMoviesList).concat(state.movieIdList)
  }
};

// actions
const actions = {
  async getMovieCompaireInfo({ commit }) {
    // commit('setError', undefined);
  },
  async addHistoryMovieList({ commit }, payload = { list: [], type: "session" }) {
    let arr = payload.list
    commit('addMovieListByLocalStorage', payload = { list: arr, type: payload.type })
    return Promise.resolve()
  },
};

// mutations
const mutations = {
  setMainMovie(state, payload = { id: id }) {
    state.mainMovieId = payload.id
    //存到localStorage
    if (payload.id) {
      storageProcess.setHistoryArray([payload.id])
    }
  },
  clearMainMovie(state) {
    state.mainMovieId = undefined
  },
  setCycleMoviesList(state, payload = { list: [] }) {
    state.cycleMoviesList = payload.list
    //存到localStorage
    storageProcess.setHistoryArray(payload.list)
  },
  clearCycleMoviesList(state) {
    state.cycleMoviesList = []
  },
  addMovieList(state, payload = { list: [] }) {
    //存到localStorage
    storageProcess.setHistoryArray(payload.list)
    //将之前的激活电影注销
    state.movieIdList.forEach(item => {
      state.movieActive[item] = false
    })
    //判断比较类型
    let lengthLimit = 15
    //去重 并 激活新添加的电影list
    let newAddList = []
    //去重(1.在mainid或者cycleid中时，由于mainid和cycleid均一直存在，直接从新添加列表中删除；2.在movielist中时，删除老movielist中的该影片)
    // 1.
    newAddList = payload.list.filter(item => {
      return (state.mainMovieId !== item && state.cycleMoviesList.indexOf(item) < 0 && item !== 0)
    })
    // 2.
    newAddList.forEach(item => {
      state.movieIdList = state.movieIdList.filter((list_item) => {
        return list_item !== item
      })
    })
    //激活-----------------------
    newAddList.forEach((item, index) => {
      state.movieActive[item] = true
    })
    //---------------------------
    // let tempMovieList = state.movieIdList.concat(newAddList)
    let tempMovieList = newAddList.concat(state.movieIdList)
    //movielist中，每次添加后， 取最新15位
    if (tempMovieList.length > lengthLimit) {
      tempMovieList = tempMovieList.slice(0, lengthLimit)
    }
    state.movieIdList = tempMovieList
    return state;
  },
  addMovieListByLocalStorage(state, payload = { list: [], type: undefined }) {
    //去重(1.在mainid或者cycleid中时，由于mainid和cycleid均一直存在，直接从新添加列表中删除；2.在movielist中时，删除新的从localtorage中取出的movielist中的该影片)
    // 1.
    let newAddList = payload.list.filter(item => {
      return (state.mainMovieId !== item && state.cycleMoviesList.indexOf(item) < 0)
    })
    let tempMovieList = state.movieIdList.concat(newAddList)
    state.movieIdList = tempMovieList
    return state;
  },
  clearMovieList(state) {
    state.movieIdList = []
  },
  updateMovieActive(state, payload = {}) {
    state.movieActive = Object.assign({}, payload)
  },
  //取消激活所有电影
  clearMovieActive(state) {
    state.movieActive = {}
  },
  updateTotalMovieState(state) {
    //激活均值和周期对比影片
    let activeMovies = [0].concat(state.cycleMoviesList).concat(state.mainMovieId)
    activeMovies.forEach((item) => {
      state.movieActive[item] = true
    })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
